import React from 'react';
import { LG, MD, SM  } from '@zendeskgarden/react-typography';

const statusMap = {
  deleted: {
    title: "This Listing No Longer Exisits",
  }
}

const ProductsStatusMessage = ({status}) => {
  const details = statusMap[status]
  return (
    <div style={{maxWidth: '700px', margin: '0 auto'}}>
      {
        details ?
        <div>
          <LG grey center paddingTopLg>
            {details.title}
          </LG>          
        </div> :
        <LG grey center paddingTopLg>
          This Listing is currently {status}
        </LG>
      }
    </div>
  )
}


export default ProductsStatusMessage;
